<template>
  <div class="mainCommonListContainer">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button @click="add()" v-if="null !== addPermission" class="addBtn"
          >{{ addPermission.name }}<i class="el-icon-plus el-icon--right"></i
        ></el-button>
      </div>

      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.name"
              placeholder="搜索驻点名称"
              @keyup.enter.native="handleCurrentChange(1)"
              ><i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
              >
              </i
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        height="491"
        style="width: 100%"
        ref="commonTable"
      >
        <el-table-column
          prop="name"
          label="名称"
          min-width="70"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          :formatter="formatterType"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="longitude"
          label="经度(度)"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="latitude"
          label="纬度(度)"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="altitude"
          label="高度(米)"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="runway_direction"
          label="跑道方向(度)"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="runway_length"
          label="跑道长度(米)"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="temp"
          label="临时驻点"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
          :formatter="formatterTemp"
        ></el-table-column>
        <el-table-column
          prop="airport_name"
          label="机场名称"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="80"
          align="center"
          v-if="buttonList.length !== 0"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div
                v-for="(button, index) in buttonList"
                :key="index"
                class="buttonClass"
              >
                <el-button
                  v-if="button.path === 'stayPointList-edit'"
                  @click="edit(scope.row)"
                  icon="el-icon-operte-view"
                  class="editBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                ><el-button
                  v-else-if="button.path === 'stayPointList-del'"
                  @click="del(scope.row)"
                  icon="el-icon-operte-view"
                  class="delBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
          height: 40px;
        "
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 16, 24, 32]"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="totalCount"
          popper-class="adminHomeSelect"
        ></el-pagination
        ><!-- , jumper -->
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="812px"
      class="commonComplexDialog"
    >
      <div class="dialog-header-separator"></div>
      <el-form
        :rules="rules"
        ref="commonForm"
        :model="commonForm"
        label-width="120px"
        @submit.native.prevent
      >
        <el-form-item prop="name" label="驻点名称" class="left-form-item">
          <el-input
            v-model="commonForm.name"
            maxlength="50"
            placeholder="请输入驻点名称"
            @keyup.enter.native="submit('commonForm')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="type" label="驻点类型">
          <el-select
            v-model="commonForm.type"
            placeholder="请选择驻点类型"
            popper-class="adminHomeSelect"
            clearable
          >
            <el-option
              v-for="planeType in planeTypes"
              :key="planeType.id"
              :label="planeType.name"
              :value="planeType.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="经度(度)"
          prop="longitude"
          class="number-adjust-item left-form-item"
          label-width="100px"
        >
          <div style="width: 100%; height: 40px; display: block">
            <el-button
              icon="el-icon-plus"
              @click="addPoint('longitude')"
            ></el-button>
            <el-input
              @keyup.enter.native="submit('commonForm')"
              v-model="commonForm.longitude"
              placeholder="请输入经度"
              maxlength="11"
            ></el-input>
            <el-button
              icon="el-icon-minus"
              @click="reducePoint('longitude')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="纬度(度)"
          prop="latitude"
          class="number-adjust-item left-form-item"
          label-width="100px"
        >
          <div style="width: 100%; height: 40px; display: block">
            <el-button
              icon="el-icon-plus"
              @click="addPoint('latitude')"
            ></el-button>
            <el-input
              @keyup.enter.native="submit('commonForm')"
              v-model="commonForm.latitude"
              placeholder="请输入纬度"
              maxlength="10"
            ></el-input>
            <el-button
              icon="el-icon-minus"
              @click="reducePoint('latitude')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="高度(米)"
          prop="altitude"
          class="number-adjust-item left-form-item"
          label-width="100px"
        >
          <div style="width: 100%; height: 40px; display: block">
            <el-button
              icon="el-icon-plus"
              @click="addPoint('altitude')"
            ></el-button>
            <el-input
              @keyup.enter.native="submit('commonForm')"
              v-model="commonForm.altitude"
              placeholder="请输入高度"
              maxlength="7"
            ></el-input>
            <el-button
              icon="el-icon-minus"
              @click="reducePoint('altitude')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="跑道方向(度)"
          prop="runway_direction"
          class="number-adjust-item"
          label-width="100px"
        >
          <div style="width: 100%; height: 40px; display: block">
            <el-button
              icon="el-icon-plus"
              @click="addPoint('runway_direction')"
            ></el-button>
            <el-input
              @keyup.enter.native="submit('commonForm')"
              v-model="commonForm.runway_direction"
              oninput="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入跑道方向"
              maxlength="3"
            ></el-input>
            <el-button
              icon="el-icon-minus"
              @click="reducePoint('runway_direction')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="跑道长度(米)"
          prop="runway_length"
          class="number-adjust-item left-form-item"
          label-width="100px"
        >
          <div style="width: 100%; height: 40px; display: block">
            <el-button
              icon="el-icon-plus"
              @click="addPoint('runway_length')"
            ></el-button>
            <el-input
              @keyup.enter.native="submit('commonForm')"
              v-model="commonForm.runway_length"
              oninput="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入跑道长度"
              maxlength="4"
            ></el-input>
            <el-button
              icon="el-icon-minus"
              @click="reducePoint('runway_length')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item prop="temp" label="临时驻点">
          <el-select
            v-model="commonForm.temp"
            placeholder="请选择驻点类型"
            popper-class="adminHomeSelect"
          >
            <el-option
              v-for="temp in temps"
              :key="temp.id"
              :label="temp.name"
              :value="temp.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          prop="station_id"
          label="所属区域"
          class="left-form-item is-required"
          v-show="checkTempType"
        >
          <el-cascader
            v-model="commonForm.area_station"
            :options="options"
            :props="{ expandTrigger: 'hover', value: 'id', label: 'value' }"
            @change="handleChange"
            popper-class="adminHomeCascader"
          >
            <template slot-scope="{ data }">
              <span>{{ data.value }}</span>
            </template>
          </el-cascader>
        </el-form-item>

        <el-form-item label="机场" v-show="checkTempType">
          <el-select
            v-model="commonForm.airport_id"
            placeholder="请选择机场"
            @change="changeAirport"
            popper-class="adminHomeSelect"
            clearable
          >
            <el-option
              v-for="airport in airports"
              :key="airport.id"
              :label="airport.name"
              :value="airport.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="formItemBtnRow">
          <el-button
            type="primary"
            @click="submit('commonForm')"
            class="confirmBtn"
            >确 定</el-button
          ><el-button @click="dialogVisible = false" class="cancelBtn"
            >取 消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Airport",
  props: ["menuId"],
  data() {
    var checkLgn = (rule, value, callback) => {
      if (value) {
        value = Number(value);
        var reg = /^-?\d+(\.\d{1,6})?$/;
        if (reg.test(value)) {
          if (180 < value) {
            callback(new Error("经度不能大于180~"));
          } else if (value < -180) {
            callback(new Error("经度不能小于-180~"));
          } else {
            callback();
          }
        } else {
          callback(new Error("经度小数位数不能超过六位~"));
        }
      } else {
        return callback(new Error("经度不能为空~"));
      }
    };
    var checkLat = (rule, value, callback) => {
      if (value) {
        value = Number(value);
        var reg = /^-?\d+(\.\d{1,6})?$/;
        if (reg.test(value)) {
          if (90 < value) {
            callback(new Error("纬度不能大于90~"));
          } else if (value < -90) {
            callback(new Error("纬度不能小于-90~"));
          } else {
            callback();
          }
        } else {
          callback(new Error("纬度小数位数不能超过六位~"));
        }
      } else {
        return callback(new Error("纬度不能为空~"));
      }
    };
    var checkAltitude = (rule, value, callback) => {
      if (value) {
        value = Number(value);
        var reg = /^-?\d+(\.\d{1,2})?$/;
        if (reg.test(value)) {
          if (8845 < value) {
            callback(new Error("高度不能大于8845米~"));
          } else if (value < -413) {
            callback(new Error("高度不能小于-413米~"));
          } else {
            callback();
          }
        } else {
          callback(new Error("高度小数位数不能超过两位~"));
        }
      } else {
        return callback(new Error("高度不能为空~"));
      }
    };
    var checkRunDirection = (rule, value, callback) => {
      if (value) {
        if (360 < value) {
          callback(new Error("跑道方向不能大于360~"));
        } else if (value < 0) {
          callback(new Error("跑道方向不能小于0~"));
        } else {
          callback();
        }
      } else {
        return callback(new Error("跑道方向不能为空~"));
      }
    };
    var checkRunLength = (rule, value, callback) => {
      if (value) {
        if (4000 < value) {
          callback(new Error("跑道长度不能大于4000米~"));
        } else if (value < 0) {
          callback(new Error("跑道长度不能小于0米~"));
        } else {
          callback();
        }
      } else {
        return callback(new Error("跑道长度不能为空~"));
      }
    };
    var checkStation = (rule, value, callback) => {
      const commonForm = this.$data.commonForm;
      if (1 == commonForm.temp && this.isEmptyStr(value)) {
        callback(new Error("非临时驻点必须选站点"));
      } else {
        callback();
      }
    };
    return {
      queryForm: {},
      title: "添加驻点",
      options: [],
      addFlag: true,
      commonForm: {},
      current: 1, //当前页数
      size: 6, //显示几条
      totalCount: 0, //总条数
      tableData: [],
      dialogVisible: false,
      addPermission: null,
      buttonList: [],
      areas: [],
      rules: {
        name: [{ required: true, message: "请输入驻点名称~", trigger: "blur" }],
        type: [
          { required: true, message: "请选择驻点类型~", trigger: "change" },
        ],
        longitude: [{ required: true, validator: checkLgn, trigger: "blur" }],
        latitude: [{ required: true, validator: checkLat, trigger: "blur" }],
        altitude: [
          { required: true, validator: checkAltitude, trigger: "blur" },
        ],
        runway_direction: [
          { required: true, validator: checkRunDirection, trigger: "blur" },
        ],
        runway_length: [
          { required: true, validator: checkRunLength, trigger: "blur" },
        ],
        temp: [
          { required: true, message: "请选择是否临时驻点~", trigger: "blur" },
        ],
        station_id: [
          { required: false, validator: checkStation, trigger: "blur" },
        ],
      },
      planeTypes: [
        {
          id: 0,
          name: "机场停机坪",
        },
        {
          id: 1,
          name: "非机场停机坪",
        },
        {
          id: 2,
          name: "机场跑道",
        },
      ],
      airports: [],
      temps: [
        {
          id: 0,
          name: "是",
        },
        {
          id: 1,
          name: "否",
        },
      ],
      pointRange: {
        longitude: { min: -180, max: 180 },
        latitude: { min: -90, max: 90 },
        altitude: { min: -413, max: 8845 },
        runway_direction: { min: 0, max: 360 },
        runway_length: { min: 0, max: 4000 },
      },
    };
  },
  mounted() {
    this.setGutterWidth();
    this.query();
    this.buttonList = [];
    this.addPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
  },
  methods: {
    getButtonList(buttonList) {
      let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];

          if (child) {
            if (child.path === "stayPointList-add") {
              this.addPermission = child;
            } else if (child.path !== "stayPointList-view") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    handleChange(selectInfo) {
      if (selectInfo) {
        this.$data.commonForm.station_id = selectInfo[1];
        this.$refs.commonForm.validateField("station_id");
        this.checkAirportStations(selectInfo);
      }
    },
    changeAirport(airportId) {
      this.$set(this.$data.commonForm, "airportId", airportId);
      this.checkStationByAirport(airportId);
    },
    checkStationByAirport(airportId) {
      try {
        const airports = this.$data.airports;
        for (let index = 0; index < airports.length; index++) {
          const element = airports[index];
          if (airportId == element.id) {
            this.$set(this.$data.commonForm, "area_station", [
              parseInt(element.area_id),
              parseInt(element.station_id),
            ]);
            break;
          }
        }
      } catch (error) {}
    },
    addPoint(type) {
      this.addOrReducePoint(type, true);
    },
    reducePoint(type) {
      this.addOrReducePoint(type, false);
    },
    add() {
      this.$data.title = "添加驻点";
      this.queryAllAirport();
      this.queryAllArea();
      this.$data.addFlag = true;
      this.$data.dialogVisible = true;
    },
    addStayPoint() {
      let vue = this;
      this.postJsonRequest(
        "/basic-info-server/staypoint/addStayPoint.do",
        this.$data.commonForm
      )
        .then((res) => {
          res = res.data;
          let type;
          let msg = "请求失败";
          if (null != res) {
            msg = res.msg;
          }
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    },
    queryAllArea() {
      let vue = this;
      this.getRequest("/basic-info-server/station/getStationGroupByArea.do")
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (!this.isEmptyArray(res.data)) {
              this.$data.options = this.resetStation(res.data);
            } else {
              this.$data.options = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    resetStation(data) {
      if (!this.isEmptyArray(data)) {
        data.forEach((element) => {
          if (!this.isEmptyArray(element.children)) {
            element.children.forEach((e) => {
              e.id = e.id;
              e.value = e.name;
            });
          }
        });
      }
      return data;
    },
    queryAllAirport(area_name, station_name) {
      let param = "";
      if (!this.isEmptyStr(area_name) && !this.isEmptyStr(station_name)) {
        param += "&area_name=" + area_name + "&station_name=" + station_name;
      }

      let vue = this;
      this.getRequest("/basic-info-server/airport/getAirPortList2.do?" + param)
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (!this.isEmptyArray(res.data)) {
              this.$data.airports = res.data;
            } else {
              this.$data.airports = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    checkAirportStations(selectInfo) {
      const areaId = selectInfo[0];
      const stationId = selectInfo[1];

      let area_name = "";
      let station_name = "";
      let area = null;
      const options = this.$data.options;

      for (let index = 0; index < options.length; index++) {
        const element = options[index];
        if (areaId == element.id) {
          area = element;
          area_name = element.value;
          break;
        }
      }

      const childrens = area.children;

      for (let index = 0; index < childrens.length; index++) {
        const element = childrens[index];
        if (stationId == element.id) {
          station_name = element.value;
          break;
        }
      }
      this.$data.commonForm.airport_id = "";
      this.queryAllAirport(area_name, station_name);
    },
    query() {
      let vue = this;
      this.getRequest(
        "/basic-info-server/staypoint/getStayPointList.do?pagesize=" +
          this.$data.size +
          "&currentpage=" +
          this.$data.current +
          this.getQueryParam()
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.totalCount = res.data.total;
              this.$data.tableData = res.data.list;
            } else {
              this.$data.totalCount = 0;
              this.$data.tableData = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //编辑
    edit(row) {
      this.doEdit(row.id);
    },
    doEdit(id) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/staypoint/getStayPointById.do", {
        id: id,
      })
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data) {
              this.$data.title = "修改驻点";
              this.queryAllAirport();
              this.queryAllArea();
              this.$data.addFlag = false;

              if (res.data.area_id && res.data.station_id) {
                res.data.area_station = [
                  parseInt(res.data.area_id),
                  parseInt(res.data.station_id),
                ];
              }

              this.$data.commonForm = res.data;
              this.$data.dialogVisible = true;
            } else {
              // let tips =
              //   "<i class='el-icon-warn-tip'></i> 啊哦,请求数据不存在~";
              // this.$confirm(tips, "提示", {
              //   confirmButtonText: "好的",
              //   customClass: "customClass-style",
              //   iconClass: "",
              //   dangerouslyUseHTMLString: true,
              //   confirmButtonClass: "confirm-style",
              //   showCancelButton: false,
              // });
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //编辑提交
    editStayPoint() {
      let vue = this;
      this.postJsonRequest(
        "/basic-info-server/staypoint/upateStayPoint.do",
        this.$data.commonForm
      )
        .then((res) => {
          res = res.data;
          let type;
          let msg = "请求失败";
          if (null != res) {
            msg = res.msg;
          }
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    }, //删除
    del(row) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.doDel(row);
        })
        .catch(() => {});
    },
    doDel(row) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/staypoint/DelStayPoint.do", row)
        .then((res) => {
          res = res.data;
          let type;
          let msg = "请求失败";
          if (null != res) {
            msg = res.msg;
          }
          if (null != res && 0 == res.code) {
            let totalPage = Math.ceil((this.totalCount - 1) / this.size);
            let currentPage =
              this.current > totalPage ? totalPage : this.current;
            this.current = currentPage < 1 ? 1 : currentPage;
            vue.query();
            vue.$message({
              message: "删除成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    }, //分页函数
    handleSizeChange: function (val) {
      this.size = val;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.$data.addFlag) {
          this.addStayPoint();
        } else if (valid && !this.$data.addFlag) {
          this.editStayPoint();
        } else {
          return false;
        }
      });
    },
    formatterType(row, column, value) {
      return this.$data.planeTypes[value].name;
    },
    formatterTemp(row, column, value) {
      return this.$data.temps[value].name;
    },
  },
  watch: {
    dialogVisible: function (nval, oval) {
      if (!nval) {
        this.$data.commonForm = {};
      }
      this.defaultClearValidate();
    },
    "commonForm.airport_id": (nval, oval) => {},
  },
  computed: {
    checkTempType() {
      return 1 == this.$data.commonForm.temp;
    },
  },
};
</script>

<style scoped>
.mainCommonListContainer {
  width: 100%;
  height: 100%;
}
</style>
<style>
.adminHomeContainer
  .el-tabs
  .el-tabs__content
  #pane-stayPointList
  .commonDialog
  .el-dialog {
  margin-top: calc(25% - 312px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/stayPoint/stayPoint.vue